import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'GET_AVG_NET_PAYOUTS'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ERROR_AVG_NET_PAYOUTS',
        errors
    };
}

export function finish(selections) {
    return {
        type: 'FINISH_AVG_NET_PAYOUTS',
        selections
    };
}
